import type { FlipperFeatureFlags } from '@libs/data-access/entities'
import { useGetAccountFlipperFeatureFlags } from '@libs/data-access/queries'
import type { FC, ReactElement, ReactNode } from 'react'

type Params = {
  flag: FlipperFeatureFlags
  active: ReactNode
  inactive?: ReactNode
}

export const FlipperFlagCondition: FC<Params> = ({
  flag,
  active,
  inactive
}) => {
  const { data: currentAccountFlipperFeatureFlags } =
    useGetAccountFlipperFeatureFlags()

  const isActive = currentAccountFlipperFeatureFlags?.[flag]
  return (isActive ? active : inactive) as ReactElement
}
